export enum FeatureFlag {
	WsuiEnablePushNotifications = 'WsuiEnablePushNotifications',
	ServiceWorkeriOS = 'WSUI3923ServiceWorkeriOS',
	ServiceWorkerCacheValidation = 'WsuiServiceWorkerCacheValidation',
	WsuiBulkDismissRecordId = 'WsuiBulkDismissRecordId',
	UseStoreFrontFallbackUrl = 'Wxp822WorkspaceResiliencyFallback',
	BrowserExtensionHybridLaunchLinux = 'WsuiEnableBrowserExtensionHybridLaunchLinux',
	ChromeAppShield = 'WsuiEnableChromeAppShield',
	RfHtml5Cdn = 'Wsp3353RfHtml5Cdn',
	WsuiFilesUIModernization = 'WSUI4527FilesUIModernization',
	LoadingMessages = 'WSUI3567FTULoadingMessaging',
	LineArtIllustrations = 'WSUI3486LineArtIllustrations',
	BrowserAppProtection = 'WSUI4148IsAppProtectionEnabled',
	FeedDefaultOn = 'Wsp12246FeedDefaultOnCC',
	SimplifiedNav = 'WSUI4905SimplifiedNavigation',
	SimplifiedNavNoSubNav = 'WSUI5244SimplifiedNavNoSubNav',
	NoAppFilterInVanityDomain = 'WSUINoAppFilterInVanityDomain',
	EnableFilesInVanityDomain = 'WSUIEnableFilesInVanityDomain',
	EnableIwsInVanityDomain = 'WSUIEnableIwsInVanityDomain',
	WspUserActionsRecent = 'WSPUserActionsRecent',
	FilesIntegrationDisabled = 'WSUI7054FilesIntegrationDisabled', //disable all Files related functionality in Workspace
	ShowSharefileApp = 'WSUI7054ShowSharefileApp', //Show ShowSharefileApp
	NoEmptyAppsOrEmptyDesktopSection = 'WSUI6395NoEmptyAppsOrEmptyDesktopSection',
	FuzzySearch = 'WSUI6282FuzzySearch', //Fuzzy Search
	PreLaunchChanges = 'WSUI6462PreLaunchChanges',
	ShareCustomerIdInSentry = 'WSUI7441ShareCustomerIdInSentry',
	PersonalIntegrations = 'WSUI7803EnablePersonalIntegrations',
	ShowFirstAndLastNameInitials = 'WSUI7293ShowFirstAndLastNameInitials',
	DisableResourceButtonWrap = 'WSUI7644DisableResourceButtonWrap', // removes button wrap(needed for accessibility) on resources so that iOS/mac(Swift) automation can identify elements within resource(ex. Favourite, More option)
	EnableUserDisplayName = 'WSHELP301EnableUserDisplayName',
	EnableUserDisplayNameOnPrem = 'Citrix.StoreFront.WorkspaceUI.EnableUsername',
	EnableInfoLogging = 'WSUI8024EnableInfoLogging',
	FirefoxExtensionEnabled = 'BXTN385FirefoxExtensionEnabled', // Firefox Extension
	ActivityManagerForceEnabled = 'WSUI8415ActivityManagerForceEnabled',
	WsuiEnableHTML5Shield = 'WSUI7563WsuiEnableHTML5Shield',
	WsuiEnableHTML5ShieldV2 = 'WSUI12120WsuiEnableHTML5ShieldV2',
	DetectClientBeforeAuthentication = 'WSUI8335DetectClientBeforeAuthentication',
	SaasAppLaunchUsingNative = 'WSUI8802SaasAppLaunchUsingNative',
	EnableHybridAADSSO = 'WSUI7083EnableHybridAADSSO',
	EnableStaleWhileRevalidate = 'WSUI8882EnableStaleWhileRevalidate',
	EnableStaleWhileRevalidateForMac = 'WSUI8882EnableStaleWhileRevalidateForMac',
	EnableStaleWhileRevalidateForWindows = 'WSUI8882EnableStaleWhileRevalidateForWindows',
	EnablePrefetchUserDetailsFromCache = 'WSUI8538EnablePrefetchUserDetailsFromCache',
	EnablePrefetchUserDetailsFromCacheForMac = 'WSUI8538EnablePrefetchUserDetailsFromCacheForMac',
	EnablePrefetchUserDetailsFromCacheForWindows = 'WSUI8538EnablePrefetchUserDetailsFromCacheForWindows',
	PromptUserToInstallBrowserExtension = 'WSUI8209PromptUserToInstallBrowserExtension',
	EnableSynchronousAppShell = 'WSUI8552EnableSynchronousAppShell',
	UseIsSubscriptionEnabledFlag = 'Wsp22502SetAllowFavouritesBugfix',
	SendICAWithEncoding = 'WSUI9234SendICAWithEncoding',
	AllowOnlyJsonIca = 'WSUI9333AllowOnlyJsonIca',
	EnableBrowserExtensionOnVanityDomains = 'WSUI9060nableBrowserExtensionOnVanityDomains',
	UseFixForDesktopAvailability = 'WSHELP417UseFixForDesktopAvailability',
	ActivityManagerRefactoring = 'WSUI9437ActivityManagerRefactoring',
	InitiateStoreInOfflineMode = 'WSUI9474BXTNInitiateStoreInOfflineMode',
	EnableCustomLinks = 'WSUI9293CustomLinkBanner',
	UseModernOfflineFlow = 'WSUI9501UseModernOfflineFlow',
	EnableGlobalAppConfigForProtocolHandler = 'WSUI9541GlobalAppConfigv2',
	InitiateResourceManagerOnLoad = 'WSUI9437InitiateResourceManagerOnLoad',
	EnableOpenCitrixForLinux = 'WSUI9765EnableOpenCitrixForLinux',
	EnableOpenCitrixForChromeOS = 'WSUI9765EnableOpenCitrixForChromeOS',
	EnableOffWhiteBackground = 'WSUI9641EnableOffWhiteBackground',
	UseServerConfigForProtocolHandler = 'WSUI9612UseServerConfirForProtocolHandler',
	SupportClientDetectionIOS = 'WSUI9953SupportClientDetectionIOS',
	SupportClientDetectionAndroid = 'WSUI9953SupportClientDetectionAndroid',
	SupportClientDetectionChromeOS = 'WSUI9953SupportClientDetectionChromeOS',
	CustomBlockingNotification = 'WSP25446CustomBlockingNotification',
	ReInitDetectionFlow = 'WSUI10062ReInitDetectionFlow',
	AllowWorkspaceControl = 'WSUI10311AllowWorkspaceControl',
	EnableMachinePowerState = 'WSUI7246EnableMachinePowerState',
	AllowBlueTheme = 'WSUI10305AllowBlueTheme',
	WSUIPowerManagementControls = 'WSUI10292PowerManagementControls',
	ShieldPRD = 'WSUI10403EnableShieldPRD',
	EnableInspectConnection = 'WSUI10031EnableInspectConnection',
	EnableHybridAADSSOMac = 'WSUI10968EnableHybridAADSSOMac',
	EnableHybridAADSSOLinux = 'WSUI10968EnableHybridAADSSOLinux',
	WSUIGACSHybridViaBXTN = 'WSUI11063GACSHybridViaBXTN',
	WSUI10821EnableChromeAppShieldPRDTelemetry = 'WSUI10821EnableChromeAppShieldPRDTelemetry',
	WSUIGACSHybridForHtml5 = 'WSUI110812GACSHybridForHtml5',
	WSUIGACSHybridForChromeApp = 'WSUI110812GACSHybridForChromeApp',
	CombinedAppProtectionChecking = 'WSUI10100CombinedAppProtectionChecking',
	CenterAlignClassicView = 'WSUI9998CenterAlignClassicView',
	EnableReadyPowerState = 'WSUI11264EnableReadyPowerState',
	EnableIcaDownloadUsingFetch = 'WSUI9266EnableIcaDownloadUsingFetch',
	EnableDisconnectAndLogout = 'WSUI11075EnableDisconnectAndLogout',
	EnableSessionReconnect = 'WSUI11047EnableSessionReconnect',
	DetailedDesktopView = 'WSUI10804DetailedDesktopView',
	ForceDetailedDesktopView = 'WSUI11795ForceDetailedDesktopView',
	EnableIdpLogoffOnSessionExpiry = 'WSUI11410EnableIdpLogoffOnSessionExpiry',
	EnablePostLaunchDelayForHybridLaunches = 'WSUI11551EnablePostLaunchDelayForHybridLaunches',
	InteractiveSearchModuleFavoriteIcon = 'WSUI11360InteractiveSearchModuleFavoriteIcon',
	EnableHTML5InitialisedEvent = 'WSUI11394EnableHTML5InitialisedEvent',
	EnableSessionReconnectForHTML5 = 'WSUI11439EnableSessionReconnectForHTML5',
	RemoveCSRFTokenFromSaaSLaunchInNewTab = 'WSUI11607RemoveCSRFTokenFromSaaSLaunchInNewTab',
	EnableServiceContinuitySupportability = 'WSUI11478EnableServiceContinuitySupportability',
	EnableBeforeunloadForProgressAlert = 'WSUI11894EnableBeforeUnloadForProgressAlert',
	EnableChromeAppInspectConnection = 'WSUI10799EnableChromeAppInspectConnection',
	EnableBXTNSetCapabilitiesRetries = 'WSUI11834EnableBXTNSetCapabilitiesRetries',
	EnableInspectConnectionForHTML5 = 'WSUI10798EnableInspectConnectionForHTML5',
	EnableGracefulRestart = 'WSUI11695EnableGracefulRestart',
	RemoveLeaseSyncTimeout = 'WSUI12127RemoveLeaseSyncTimeout',
	EnableHTML5StarterSDK = 'WSUI11622EnableHTML5StarterSDK',
	EnableGranularPowerAction = 'WSUI11679EnableGranularPowerAction',
	EnableChromeAppPoiTelemetry = 'WSUI12295EnableChromeAppPoiTelemetry',
	AllowCasTelemetryWhenCloudOffline = 'WSUI12295AllowCasTelemetryWhenCloudOffline',
}
